import React from 'react';

import { Stack } from '@mui/material';

import AtolDatedFieldsEditor from './AtolDatedFieldsEditor';
import AtolDescriptionFieldEditor from './AtolDescriptionFieldEditor';
import AtolFlightLegsEditor from './AtolFlightLegsEditor';
import AtolRoomFieldsEditor from './AtolRoomFieldsEditor';
import { type AnyItem, type DateValidationError, type EditableItem } from './atolEditHelpers';

interface AtolItemContentEditorProps {
  editItem: EditableItem;
  dateErrors: Array<DateValidationError>;
  isLoading: boolean;
  onUpdateField: (itemId: string, updater: (current: AnyItem) => AnyItem) => void;
}

export default function AtolItemContentEditor({
  editItem,
  dateErrors,
  isLoading,
  onUpdateField,
}: AtolItemContentEditorProps) {
  const { groupKey } = editItem;

  if (groupKey === 'flights' || groupKey === 'offlineFlights') {
    return (
      <AtolFlightLegsEditor
        editItem={editItem}
        dateErrors={dateErrors}
        isLoading={isLoading}
        onUpdateField={onUpdateField}
      />
    );
  }

  return (
    <Stack spacing={2}>
      <AtolDescriptionFieldEditor editItem={editItem} isLoading={isLoading} onUpdateField={onUpdateField} />
      <AtolRoomFieldsEditor editItem={editItem} isLoading={isLoading} onUpdateField={onUpdateField} />
      <AtolDatedFieldsEditor
        editItem={editItem}
        dateErrors={dateErrors}
        isLoading={isLoading}
        onUpdateField={onUpdateField}
      />
    </Stack>
  );
}
